import { XCircle } from 'lucide-react'
import type { CSSProperties } from 'react'

type ChipProps = {
  name: string
  colour: string
  icon?: string | React.ReactNode
  onRemove?: () => void
}

// Lets React's style prop accept our custom CSS variable (not in CSSProperties by default).
type ChipStyle = CSSProperties & {
  '--chip-colour': string
}

export const Chip = ({ name, icon, colour, onRemove }: ChipProps) => {
  // Free-form hex from the DB/picker can be too bright as text (e.g. yellow).
  // We stash it in --chip-colour, then derive a soft tint + darkened/lightened text
  // via color-mix — same idea as Badge's yellow-800-on-yellow-400/20, without presets.
  return (
    <span
      className="inline-flex items-center rounded-md px-1.5 py-0.5 text-sm/5 font-medium sm:text-xs/5 forced-colors:outline bg-[color-mix(in_srgb,var(--chip-colour)_15%,transparent)] text-[color-mix(in_srgb,var(--chip-colour)_65%,black)] dark:bg-[color-mix(in_srgb,var(--chip-colour)_20%,transparent)] dark:text-[color-mix(in_srgb,var(--chip-colour)_75%,white)]"
      style={{ '--chip-colour': colour } as ChipStyle}
    >
      {icon && (
        <span
          aria-hidden="true"
          className="mr-2"
        >
          {icon}
        </span>
      )}
      {name}
      {onRemove && (
        <button
          type="button"
          aria-label={`Remove ${name}`}
          className="cursor-pointer ml-2 rounded-sm transition-opacity duration-200 hover:opacity-50 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-primary-500"
          onClick={onRemove}
        >
          <XCircle
            aria-hidden="true"
            className="size-4"
          />
        </button>
      )}
    </span>
  )
}

export default Chip
